module.exports = __webpack_public_path__ + "img/yandex.749aa63b.png";